import { useLocale } from "@hooks";
import { useMemo } from "react";
import { UserLang } from "@constants/common";

export const useFetchMarkdownContent = ({ query, name = "content" }) => {
	const { currentLanguage } = useLocale();

	const convertedContent = (markdownContents: any) => {
		if (markdownContents.length === 0) return [];
		const firstItem = markdownContents[0];
		if (firstItem) {
			return firstItem?.content;
		}
		return "";
	};

	const { content } = useMemo(() => {
		if (!query?.aepsyCms) {
			return { content: "" };
		}
		const { aepsyCms } = query;

		switch (currentLanguage) {
			case UserLang.English:
				return {
					content: convertedContent(aepsyCms[`${name}EN`]),
				};
			case UserLang.French:
				return {
					content: convertedContent(aepsyCms[`${name}FR`]),
				};
			case UserLang.Italian:
				return {
					content: convertedContent(aepsyCms[`${name}IT`]),
				};
			case UserLang.German:
			default:
				return {
					content: convertedContent(aepsyCms[`${name}DE`]),
				};
		}
	}, [query, currentLanguage]);

	return { content };
};
